<template>
    <div class="batchSending">
        <div class="left_list">
            <div class="title">聊天发送人</div>
            <div class="search">
                <!-- <el-checkbox size="22" v-model="checked" class="checkbox" @change="handleSelectAll"></el-checkbox> -->
                <el-input placeholder="搜索" prefix-icon="el-icon-search" v-model="input">
                </el-input>
            </div>
            <div class="list">
                <div class="item" v-for="item in list" :key="item.recId" @click="checkItem(item)">
                    <!-- <el-checkbox size="22" v-model="item.checked" class="checkbox" @click.stop></el-checkbox> -->
                    <div :class="['card', item.checked ? 'activeCard' : '']">
                        <img class="cardImg" :src="item.mfUserDetail?.thumbnailUrl" alt="">
                        <div class="card_info">
                            <div class="name">{{ item.mfUserDetail?.name }}</div>
                            <!-- <div class="num">123456</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table">
            <div class="title">
                <el-tabs class="title_tabs" v-model="activeName">
                    <el-tab-pane label="信息" name="first"></el-tab-pane>
                    <el-tab-pane label="邮件" name="second"></el-tab-pane>
                </el-tabs>
                <div class="flex middle">
                    <el-dropdown class="mb-12" placement="top-start" trigger="click" v-if="activeName == 'second'">
                        <span class="el-dropdown-link">
                            <p class="row"> <img src="@/assets/fyIcon.png" alt="">{{ getCurrentLanguageText() }}</p>
                        </span>
                        <el-dropdown-menu>
                            <div class="languageList">
                                <el-dropdown-item @click.native="selectedLanguage = 'en'">
                                    <div class="languageOption">
                                        <span>英语</span>
                                        <span v-if="selectedLanguage === 'en'" class="checkIcon">✓</span>
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="selectedLanguage = 'es'">
                                    <div class="languageOption">
                                        <span>西班牙语</span>
                                        <span v-if="selectedLanguage === 'es'" class="checkIcon">✓</span>
                                    </div>
                                </el-dropdown-item>
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button v-if="activeName == 'first'" @click="openDialogShow" class="titleBtn" type="primary"
                        icon="el-icon-plus" size="small">添加</el-button>
                    <el-button v-if="activeName == 'second'" @click="openEmlDialogShow" class="titleBtn" type="primary"
                        icon="el-icon-plus" size="small">添加</el-button>
                </div>
            </div>

            <div>
                <el-table v-if="activeName == 'first'" :data="tableData" style="width: 100%">
                    <el-table-column prop="templateName" label="模版名称">
                    </el-table-column>
                    <el-table-column prop="serious" label="Serious">
                    </el-table-column>
                    <el-table-column prop="penPal" label="Pen pal">
                    </el-table-column>
                    <el-table-column prop="romantic" label="Romantic">
                    </el-table-column>
                    <el-table-column prop="flirty" label="Flirty">
                    </el-table-column>
                    <el-table-column prop="naughty" label="Naughty">
                    </el-table-column>
                    <el-table-column>
                        <template slot-scope="scope">
                            <el-button class="send" @click="handleClick(scope.row)" type="text"
                                size="small">发送/停止</el-button>
                            <el-button class="status" type="text" size="small">{{ scope.row.mingleStatus ==
                                0 ? '未开启' : '已开启' }}</el-button>
                            <el-button icon="el-icon-edit" type="text" @click="editClick(scope.row)"
                                size="small">编辑</el-button>
                            <el-button icon="el-icon-delete" type="text" @click="delClick(scope.row)" size="small"
                                style="color: #F56C6C;">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="emList" v-else-if="activeName == 'second' && EmailList.length > 0">
                    <div class="emList_item" v-for="item in EmailList" :key="item.recId">
                        <div class="emList_name">
                            <div class="name"> {{ getEmailSubject(item) }}</div>
                            <div class="time">2025/2/12 12:12</div>
                        </div>
                        <div class="emList_content">{{ getEmailContent(item) }}</div>
                        <div class="btns">
                            <div class="statusBtn" v-if="item.auditStatus == 1">待提交</div>
                            <div class="statusBtn" v-if="item.auditStatus == 2">审核中</div>
                            <div class="statusBtn" v-if="item.auditStatus == 3">审核通过</div>
                            <div class="statusBtn" v-if="item.auditStatus == 4">审核未通过</div>
                            <el-button v-if="item.auditStatus == 1 || item.auditStatus == 2 || item.auditStatus == 4"
                                @click="examine(item)" type="success" icon="el-icon-s-promotion"
                                size="small">提交审核</el-button>
                            <el-button type="warning" icon="el-icon-edit-outline" size="small"
                                @click="editEmailClick(item)">编辑</el-button>
                            <el-button type="danger" icon="el-icon-delete-solid" size="small"
                                @click="delEmailClick(item)">删除</el-button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <el-dialog :title="title" :visible.sync="dialogShow" width="30%">
            <el-form ref="form" :model="form" label-width="85px" :rules="rules">
                <el-form-item label="模版名称" prop="templateName">
                    <el-input v-model="form.templateName"></el-input>
                </el-form-item>
                <el-form-item label="Serious" prop="serious">
                    <el-input v-model="form.serious"></el-input>
                </el-form-item>
                <el-form-item label="Pen pal" prop="penPal">
                    <el-input v-model="form.penPal"></el-input>
                </el-form-item>
                <el-form-item label="Romantic" prop="romantic">
                    <el-input v-model="form.romantic"></el-input>
                </el-form-item>
                <el-form-item label="Flirty" prop="flirty">
                    <el-input v-model="form.flirty"></el-input>
                </el-form-item>
                <el-form-item label="Naughty" prop="naughty">
                    <el-input v-model="form.naughty"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit('form')">保存</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
        <el-dialog title="" class="emailDialog" :visible.sync="elDialogShow" width="825px" :before-close="handleClose">
            <sendEmail @closeSendEmail="closeSendEmail" v-if="elDialogShow" :chatUserInfo="chatUserInfo"
                :openType="openType" :emailType="emailType" @itemClick="itemClick" :emailFileList="emailFileList">
            </sendEmail>
        </el-dialog>
        <el-dialog title="" class="attachmentDialog" :visible.sync="attachmentShow" width="80vw"
            :before-close="attachmentClose">
            <div class="attachmentBox">
                <!-- chatUserInfo.platformType -->
                <attachment :attachmentShow="attachmentShow" :platformType="chatUserInfo.platformType"
                    :platformUserId='chatUserInfo.platformUserId' :userId="chatUserInfo.userId"
                    @send-sonMediaMessage='sendSonMediaMessage'></attachment>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { myList, letMingleList, letMingleSend, letMingleStopeSend, addLetMingle, editLetMingle, letMingleRecIds } from '@/api/batchSending.js'
import { introductoryEmailList, introductoryEmailSubmit, introductoryEmailRecId, introductoryEmailRecIds } from '@/api/batchSending.js'
import sendEmail from '../message/components/sendEmail.vue'
import attachment from '../message/components/attachment.vue'
export default {
    components: {
        sendEmail,
        attachment
    },
    data() {
        return {
            title: '添加信息',
            dialogShow: false,
            elTitle: '新增邮件类型邀请',
            elDialogShow: false,
            form: {
                platformUserId: undefined,
                platformType: undefined,
                templateName: undefined,
                serious: undefined,
                penPal: undefined,
                romantic: undefined,
                flirty: undefined,
                naughty: undefined
            },
            rules: {
                templateName: [{ required: true, message: 'Please enter the activity templateName', trigger: 'blur' }],
                serious: [{ required: true, message: 'Please enter serious', trigger: 'blur' }],
                penPal: [{ required: true, message: 'Please enter pen pal', trigger: 'blur' }],
                romantic: [{ required: true, message: 'Please enter romantic', trigger: 'blur' }],
                flirty: [{ required: true, message: 'Please enter flirty', trigger: 'blur' }],
                naughty: [{ required: true, message: 'Please enter naughty', trigger: 'blur' }]
            },
            checked: false,
            input: '',
            list: [],
            total: 0,
            activeName: 'first',

            params: {
                // pageNum: 1,
                // pageSize: 10,
            },
            EmailListParams: {
                pageNum: 1,
                pageSize: 10,
                platformUserId: undefined,
                platformType: undefined,
            },
            EmailList: [],  // 邮件类型邀请列表
            EmailListTotal: 0,  // 邮件类型邀请列表总数
            letMingleListParams: {
                pageNum: 1,
                pageSize: 10,
                platformUserId: undefined,
                platformType: undefined,
            },
            tableData: [],
            letMingleTotal: 0, // 邀请语列表总数
            emailShow: false,
            chatUserInfo: {
                userDetail: {

                },
                emailSubject: '',
                emailContent: '',
                emailType: 2
            },
            emailType: 2, // 邮件类型
            checkItemInfo: {},
            openType: 1,
            emailFileList: [],
            attachmentShow: false, // 附件上传弹窗
            selectedLanguage: 'en', // 当前选中的语言版本
        }
    },
    mounted() {
        this.initGetMyList()
        this.getDtCommissionSysUser()
    },
    methods: {
        async getDtCommissionSysUser() {
            let res = await dtCommissionSysUser({
                startTime: '',
                endTime: '',
                pageSize: this.pageSize,
                pageNum: this.pageNum
            })
            if (res.code == 200) {
                this.dtCommissionSysUser = res.data
            }
            console.log(res);
        },
        getCurrentLanguageText() {
            switch (this.selectedLanguage) {
                case 'es':
                    return '西班牙语'
                case 'en':
                default:
                    return '英语'
            }
        },
        getEmailSubject(item) {
            switch (this.selectedLanguage) {
                case 'es':
                    return item.emailEsSubject
                case 'en':
                default:
                    return item.emailSubject // 英语内容
            }
        },
        getEmailContent(item) {
            switch (this.selectedLanguage) {
                case 'es':
                    return item.emailEsContent || '该邮件未翻译西班牙语'
                case 'en':
                default:
                    return item.emailContent || '该邮件未翻译英语' // 英语内容
            }
        },
        resetForm() {
            this.form = {
                platformUserId: undefined,
                platformType: undefined,
                templateName: undefined,
                serious: undefined,
                penPal: undefined,
                romantic: undefined,
                flirty: undefined,
                naughty: undefined
            }
        },

        openDialogShow() {
            this.title = '新增邀请语'
            this.dialogShow = true
        },
        openEmlDialogShow() {
            this.elTitle = '新增邮件类型邀请'
            this.openType = 1
            console.log(this.checkItemInfo, 'checkItemInfo')
            this.chatUserInfo = {
                userDetail: {},
                emailSubject: '',
                emailContent: '',
                emailType: 2
            }
            this.chatUserInfo.userDetail = this.checkItemInfo.mfUserDetail
            // this.chatUserInfo.recId = this.checkItemInfo.recId
            this.elDialogShow = true
        },
        itemClick(id) {
            this.emailFileList = [];
            this.emailFileFlag = true // 附件上传标志
            this.attachmentShow = true
        },
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.form.platformUserId = this.letMingleListParams.platformUserId
                    this.form.platformType = this.letMingleListParams.platformType
                    console.log(this.form);
                    if (this.form.recId) {
                        // 修改
                        editLetMingle(this.form).then(res => {
                            if (res.code == 200) {
                                this.$message.success('Updated successfully')
                                this.dialogShow = false
                                this.getLetMingleList()
                            }
                        })
                    } else {
                        // 新增
                        addLetMingle(this.form).then(res => {
                            if (res.code == 200) {
                                this.$message.success('Added successfully')
                                this.dialogShow = false
                                this.getLetMingleList()
                            }
                        })
                    }
                    this.resetForm()
                }
            })
        },
        async initGetMyList() {
            let res = await myList({})
            if (res.code == 200) {
                this.list = res.rows.map(item => {
                    return {
                        ...item,
                        checked: false
                    }
                })
                this.total = res.total
            }
        },
        closeSendEmail() {
            this.elDialogShow = false
            this.getIntroductoryEmailList()
        },
        checkItem(item) {
            // 实现单选逻辑：先取消所有其他项的选中状态
            this.list.forEach(listItem => {
                listItem.checked = false
            })

            // 如果当前项未选中，则选中它
            if (!item.checked) {
                item.checked = true
                this.checkItemInfo = item
                this.chatUserInfo.userDetail = item.mfUserDetail
                this.chatUserInfo.recId = item.recId
                this.letMingleListParams.platformUserId = item.platformUserId
                this.letMingleListParams.platformType = item.platformType
                this.getLetMingleList()
                this.EmailListParams.platformUserId = item.platformUserId
                this.EmailListParams.platformType = item.platformType
                this.getIntroductoryEmailList()
            }
        },
        sendSonMediaMessage(v) {
            console.log('子组件发送消息', v);
            this.attachmentShow = false;
            const type = v.bTypeVal,
                res = v.dataMsgList;

            if (this.emailFileFlag) {
                this.emailFileList.push({
                    type,
                    url: res.url,
                    ossId: res.ossId,
                })
                return
            }
            this.$refs.uploader.clearFiles();
        },
        handleClose(done) {
            this.elDialogShow = false
        },
        editEmailClick(item) {
            let userInfo = this.$store.state.user.user
            console.log(userInfo);
            introductoryEmailRecId(item.recId).then(res => {
                // this.chatUserInfo = res.data
                // this.chatUserInfo = {

                //     emailContent: res.data.emailContent,
                //     emailSubject: res.data.emailSubject,
                //     emailPhotoUrl: res.data.emailPhotoUrl?res.data.emailPhotoUrl.split(','):'',
                // }
                this.chatUserInfo.emailContent = res.data.emailContent
                this.chatUserInfo.emailSubject = res.data.emailSubject
                this.chatUserInfo.emailPhotoUrl = res.data.emailPhotoUrl ? res.data.emailPhotoUrl.split(',') : ''
                this.chatUserInfo.emailVideoUrl = res.data.emailVideoUrl ? res.data.emailVideoUrl.split(',') : ''
                this.chatUserInfo.emailAudioUrl = res.data.emailAudioUrl ? res.data.emailAudioUrl.split(',') : ''
                this.chatUserInfo.emailPhoto = res.data.emailPhoto ? res.data.emailPhoto.split(',') : ''
                this.chatUserInfo.emailVideo = res.data.emailVideo ? res.data.emailVideo.split(',') : ''
                this.chatUserInfo.emailAudio = res.data.emailAudio ? res.data.emailAudio.split(',') : ''
                this.chatUserInfo.emailType = 2
                this.chatUserInfo.recId = res.data.recId
                this.openType = 2
                this.elDialogShow = true
            })
        },
        delEmailClick(item) {
            this.$confirm('确定要删除这条邀请语吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                introductoryEmailRecIds(item.recId).then(res => {
                    if (res.code == 200) {
                        this.$message.success('删除成功')
                        this.getIntroductoryEmailList()
                    }
                })
            }).catch(() => {
                this.$message.info('已取消删除')
            })

        },
        // 获取邮件模版列表
        async getIntroductoryEmailList() {
            let res = await introductoryEmailList(this.EmailListParams)
            this.EmailList = res.rows
            this.EmailListTotal = res.total
        },
        // 获取模板列表
        async getLetMingleList() {
            let res = await letMingleList(this.letMingleListParams)
            this.tableData = res.rows
            this.letMingleTotal = res.total
        },
        async handleClick(row) {
            let res
            if (row.mingleStatus) {
                res = await letMingleStopeSend({ recId: row.recId })
                this.getLetMingleList()
            } else {
                res = await letMingleSend({ recId: row.recId })
                this.getLetMingleList()
            }
            console.log(res);
        },
        editClick(row) {
            let response = cloneDeep(row)
            this.form = {
                ...this.form,
                ...response
            }
            this.title = '修改邀请语'
            this.dialogShow = true
        },
        delClick(row) {
            console.log('213132')
            this.$confirm('确定要删除这条邀请语吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                letMingleRecIds(row.recId).then(res => {
                    if (res.code == 200) {
                        this.$message.success('删除成功')
                    }
                    this.getLetMingleList()
                })
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
        async examine(item) {
            let res = await introductoryEmailSubmit({ recId: item.recId })
            if (res.code == 200) {
                this.$message.success('success')
                this.getIntroductoryEmailList()
            }
        },
        attachmentClose() {
            this.attachmentShow = false
        },
        handleSelectAll() {
            // 处理全选逻辑
        },
    },
}
</script>

<style scoped lang='scss'>
.send {
    font-weight: 400;
    font-size: 18px;
    color: #0BC253;
}

.status {
    font-weight: 400;
    font-size: 18px;
    color: #FF8C3F;
}

.batchSending {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    border-radius: 8px;

    .left_list {
        width: 484px;
        box-sizing: border-box;
        padding: 28px;
        background-color: #fff;


        .title {
            font-weight: 500;
            font-size: 20px;
            color: #333333;
            margin-bottom: 24px;
        }

        .search {
            display: flex;
            align-items: center;
            margin-bottom: 18px;

            .checkbox {
                margin-right: 16px;
            }
        }
    }

    .list {
        box-sizing: border-box;
        overflow-y: auto;
        height: calc(100vh - 230px);

        .item {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            cursor: pointer;


            .card {
                box-sizing: border-box;
                width: 100%;
                display: flex;
                align-items: center;
                // margin-left: 16px;
                padding: 12px;
                border-radius: 8px;
                background-color: #F7F9FA;



                .cardImg {
                    width: 48px;
                    height: 48px;
                    border-radius: 8px;
                    margin-right: 10px;
                }

                .card_info {
                    height: 100%;
                    display: flex;
                    flex-direction: column;


                    .name {
                        font-weight: 500;
                        font-size: 18px;
                        color: #333333;
                        margin-bottom: 12px;
                    }

                    .num {
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                    }
                }
            }

            .activeCard {
                box-sizing: border-box;
                border: 1px solid #cccccc;
                background-color: #Fff;
            }

        }

    }

    .table {
        flex: 1;
        background-color: #F7F9FA;
        box-sizing: border-box;
        padding-left: 28px;

        .title {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .title_tabs {
                width: 60%;
            }

            .titleBtn {
                margin-bottom: 12px;
            }
        }

        .emList {
            box-sizing: border-box;
            padding: 16px;
            border-radius: 8px;
            background-color: #fff;

            .emList_item {
                background-color: #F7F9FA;
                box-sizing: border-box;
                padding: 18px;
                border-radius: 8px;
                margin-bottom: 20px;

                .emList_name {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 18px;

                    .name {
                        font-weight: 400;
                        font-size: 20px;
                    }

                    .time {
                        font-weight: 400;
                        font-size: 16px;
                        color: #999999;
                    }
                }

                .emList_content {
                    font-weight: 400;
                    font-size: 18px;
                    color: #333333;
                    line-height: 25px;
                    margin-bottom: 18px;
                }

                .btns {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    .statusBtn {
                        margin-right: 16px;
                        padding: 4px 8px;
                        background-color: #fff;
                        border-radius: 8px;
                        border: 1px solid #cccccc;
                    }
                }
            }
        }
    }
}

::v-deep .el-dialog {
    border-radius: 30px;
}

::v-deep .el-dialog__header {
    padding: 0;
}

::v-deep .el-dialog__body {
    padding: 24px;
}

.emailDialog {
    ::v-deep .el-dialog__body {
        padding: 0;
        border-radius: 18px;
        padding-bottom: 24px;
    }
}

.row {
    display: flex;
    padding: 12px 40px;

    img {
        width: 22px;
        height: 18px;
        margin-right: 8px;
    }
}

.languageList {
    padding: 8px 0;
}

.languageOption {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.checkIcon {
    color: #FF2424;
    font-weight: bold;
}

:deep(.el-dropdown-menu__item.active) {
    color: #FF2424;
    background-color: #fff5f5;
}

:deep(.el-dropdown-menu__item.disabled) {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
}
</style>